import { EAnalyticsEvents } from '@/_analytic/_types';
import { sendAnalyticsEvent } from '@/_analytic/send-analytics-event';
import { TArticleContentNavigationButtonClickEventParams } from './_types';

export const articleContentNavigationButtonClickEvent = (
  params: TArticleContentNavigationButtonClickEventParams,
) => {
  sendAnalyticsEvent({
    name: EAnalyticsEvents.IN_ARTICLE_ON_HEADER_CONTENTS_CLICK,
    params,
  });
};
